import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../../src/drafts/MarkdownViewer/MarkdownViewer.docs.json';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {MarkdownViewer} from '@primer/react/drafts'
`}</code></pre>
    <p>{`The `}<inlineCode parentName="p">{`MarkdownViewer`}</inlineCode>{` displays rendered Markdown and handles interaction (link clicking and checkbox checking/unchecking) with that content.`}</p>
    <h2>{`Examples`}</h2>
    <h3>{`Simple Example`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline drafts",
        "live": true,
        "noinline": true,
        "drafts": true
      }}>{`const MarkdownViewerExample = () => {
  return (
    // eslint-disable-next-line github/unescaped-html-literal
    <MarkdownViewer dangerousRenderedHTML={{__html: '<strong>Lorem ipsum</strong> dolor sit amet.'}} />
  )
}

render(MarkdownViewerExample)
`}</code></pre>
    <h3>{`Link-Handling Example`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline drafts",
        "live": true,
        "noinline": true,
        "drafts": true
      }}>{`const MarkdownViewerExample = () => {
  return (
    <MarkdownViewer
      // eslint-disable-next-line github/unescaped-html-literal
      dangerousRenderedHTML={{__html: "<a href='https://example.com'>Example link</a>"}}
      onLinkClick={ev => console.log(ev)}
    />
  )
}

render(MarkdownViewerExample)
`}</code></pre>
    <h3>{`Checkbox Interaction Example`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline drafts",
        "live": true,
        "noinline": true,
        "drafts": true
      }}>{`const markdownSource = \`
text before list

- [ ] item 1
- [ ] item 2

text after list\`

const renderedHtml = \`
<p>text before list</p>
<ul class='contains-task-list'>
  <li class='task-list-item'><input type='checkbox' class='task-list-item-checkbox' disabled/> item 1</li>
  <li class='task-list-item'><input type='checkbox' class='task-list-item-checkbox' disabled/> item 2</li>
</ul>
<p>text after list</p>\`

const MarkdownViewerExample = () => {
  return (
    <MarkdownViewer
      dangerousRenderedHTML={{__html: renderedHtml}}
      markdownValue={markdownSource}
      onChange={value => console.log(value) /* save the value to the server */}
      disabled={false}
    />
  )
}

render(MarkdownViewerExample)
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: false,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: true,
      usageExamplesDocumented: false,
      hasStorybookStories: false,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      